// js/custom-element/section/cart/item-quantity.js
if (!customElements.get('line-item-quantity')) {
  var LineItemQuantity = class extends CustomHTMLElement {
    connectedCallback() {
      this.delegate.on('click', 'a', this._onQuantityLinkClicked.bind(this));
      this.delegate.on('change', 'input', this._onQuantityChanged.bind(this));
    }
    _onQuantityLinkClicked(event, target) {
      event.preventDefault();
      this._updateFromLink(target.href);
    }
    _onQuantityChanged(event, target) {
      this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=${target.value}&line=${target.getAttribute('data-line')}`);
    }
    async _updateFromLink(link) {
      if (window.themeVariables.settings.pageType === 'cart') {
        window.location.href = link;
        return;
      }
      const changeUrl = new URL(link, `https://${window.themeVariables.routes.host}`),
        searchParams = changeUrl.searchParams,
        line = searchParams.get('line'),
        id = searchParams.get('id'),
        quantity = parseInt(searchParams.get('quantity'));
      this.dispatchEvent(new CustomEvent('line-item-quantity:change:start', { bubbles: true, detail: { newLineQuantity: quantity } }));
      const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
        body: JSON.stringify({ line, id, quantity, sections: ['mini-cart'] }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        const cartContent = await response.json();
        this.dispatchEvent(new CustomEvent('line-item-quantity:change:end', { bubbles: true, detail: { cart: cartContent, newLineQuantity: quantity } }));
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart: cartContent,
              replacementDelay: quantity === 0 ? 600 : 750,
            },
          })
        );
      } else {
        this.dispatchEvent(new CustomEvent('line-item-quantity:change:end', { bubbles: true }));
      }
    }
  };
  window.customElements.define('line-item-quantity', LineItemQuantity);
}
// js/custom-element/section/cart/line-item.js
if (!customElements.get('line-item')) {
  var LineItem = class extends HTMLElement {
    connectedCallback() {
      this.lineItemLoader = this.querySelector('.line-item__loader');
      this.addEventListener('line-item-quantity:change:start', this._onQuantityStart.bind(this));
      this.addEventListener('line-item-quantity:change:end', this._onQuantityEnd.bind(this));
    }
    _onQuantityStart() {
      if (!this.lineItemLoader) {
        return;
      }
      this.lineItemLoader.hidden = false;
      this.lineItemLoader.firstElementChild.hidden = false;
      this.lineItemLoader.lastElementChild.hidden = true;
    }
    async _onQuantityEnd(event) {
      if (event?.detail?.cart['item_count'] === 0) {
        return;
      }
      if (this.lineItemLoader) {
        await this.lineItemLoader.firstElementChild.animate({ opacity: [1, 0], transform: ['translateY(0)', 'translateY(-10px)'] }, 75).finished;
        this.lineItemLoader.firstElementChild.hidden = true;
        if (event?.detail?.newLineQuantity === 0) {
          await this.animate({ opacity: [1, 0], height: [`${this.clientHeight}px`, 0] }, { duration: 300, easing: 'ease' }).finished;
          this.remove();
        } else {
          this.lineItemLoader.lastElementChild.hidden = false;
          await this.lineItemLoader.lastElementChild.animate({ opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] }, { duration: 75, endDelay: 300 }).finished;
          this.lineItemLoader.hidden = true;
        }
      }
    }
  };
  window.customElements.define('line-item', LineItem);
}
